import { Typography } from '@design-system/components/typography/typography';
import { Modal } from '@design-system/components/modal/modal';
import { Button } from '@design-system/components/button/button';
import { LibraryVM } from '../view-models/library.viewModel';

export const DeleteConfirmationModal = (p: LibraryVM) => {
  const text =
    p.openModal.type === 'DeleteVideoConfirmation'
      ? 'Are you sure you want to delete this file from your library?'
      : p.openModal.type === 'BulkDeleteConfirmation'
      ? 'Are you sure you want to delete these items from your library?'
      : p.openModal.type === 'DeleteFolderConfirmation'
      ? 'Are you sure you want to delete this folder from your library?'
      : '';

  const onClick =
    p.openModal.type === 'DeleteVideoConfirmation'
      ? () => p.dispatch('confirmVideoDelete')
      : p.openModal.type === 'BulkDeleteConfirmation'
      ? () => p.dispatch('confirmBulkDelete')
      : p.openModal.type === 'DeleteFolderConfirmation'
      ? () => p.dispatch('confirmFolderDelete')
      : () => null;

  return (
    <Modal
      isOpen={
        p.openModal.type === 'DeleteVideoConfirmation' ||
        p.openModal.type === 'BulkDeleteConfirmation' ||
        p.openModal.type === 'DeleteFolderConfirmation'
      }
      onClose={() => p.dispatch('closeConfirmation')}
      title="Delete your content?"
      disableBackdropClick={true}
      modalClassName="w-[450px]"
    >
      <div className="flex flex-col gap-6">
        <Typography variant="bodyLarge">{text}</Typography>
        <div className="flex justify-between">
          <Button
            onClick={() => p.dispatch('closeConfirmation')}
            color="neutral"
          >
            Cancel
          </Button>
          <Button onClick={onClick} variant="text" color="neutral">
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};
